import { BaseEditViewStore, BaasicDropdownStore } from "core/stores";
import { FacilityMissingDocsEditForm } from 'application/facility-missing-docs/forms';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { action, observable } from "mobx";
import { ModalParams } from "core/models";
import _ from "lodash";
import { inactiveReasons } from 'core/constants';
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";

class FacilityMissingDocsEditViewStore extends BaseEditViewStore {
    @observable accessor facilityOrderTemplate;
    @observable accessor isItemVisible = false;
    @observable accessor eligibilityStatus = false;
    constructor(rootStore, componentsProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        const facilityOrderTemplate = componentsProps.item;
        super(rootStore, {
            name: 'facility-missing-docs-edit',
            Form: FacilityMissingDocsEditForm,
            id: facilityOrderTemplate.id,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async () => {
                       
                        return {...facilityOrderTemplate,
                            facilityOrderTemplateMissingDocuments: facilityOrderTemplate.facilityOrderTemplateMissingDocuments.map(i => ({ ...i.missingDocument, facilityOrderTemplateMissingDocumentId: i.id, note: i.note }))
                        };
                    },
                    update: async (resource) => {
                        resource.facilityOrderTemplateMissingDocuments = resource.facilityOrderTemplateMissingDocuments && resource.facilityOrderTemplateMissingDocuments.map(i => { return { missingDocumentId: i.id, note: i.note } });
                        const response = await facilityOrderTemplateService.updateNewFlowClinicalTemplate({ ...facilityOrderTemplate, ...resource });
                        return response.data;
                    },
                }
            },
            FormClass: FacilityMissingDocsEditForm
        });

        this.rootStore = rootStore;
        this.isCurrent = componentsProps.isCurrent;
        this.missingDocuments = componentsProps.missingDocuments;
        this.lookups = componentsProps.lookups;
        this.isTemplatePreview = componentsProps.isTemplatePreview;
        this.facilityOrderTemplate = facilityOrderTemplate;
        this.facilityOrderTemplateService = facilityOrderTemplateService;
        this.showItems = componentsProps.showItems;
        this.inactiveReason = inactiveReasons.find(i => i.id == facilityOrderTemplate.inactiveReasonId && i.id != 0);
        this.facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);

        this.facilityOrderTemplateMissingDocumentNoteModal = new ModalParams({ onClose: () =>  this.form.submit()});

        this.missingDocumentStore = new BaasicDropdownStore({ multi: true, filterable: true }, {
            fetchFunc: async (term = "") => {
                return this.filterMissingDocumentStore(this.missingDocuments.filter(mc => (mc.itemCategoryId === this.facilityOrderTemplate.subCategory.itemCategoryId || !mc.itemCategoryId) && mc.name.toLowerCase().includes(term.toLowerCase())));
            },
            onChange: () => {
                this.form.submit();
            }
        });
    }

    @action
    async initialize() {
        if (this.isEdit) {
            await this.getResource(this.id);
        } else {
            this.form.clear();
        }
        if(!this.facilityOrderTemplate.clinicalStatus){
            const facilityOrderPatients = (await this.facilityOrderPatientService.find({ facilityOrderId: this.facilityOrderTemplate.facilityOrderId, patientId: this.facilityOrderTemplate.patientId, embed: "EligibilityStatus", fields: "facilityOrderId,patientId,eligibilityStatus" })).data.item;
            this.eligibilityStatus = facilityOrderPatients && facilityOrderPatients[0] && facilityOrderPatients[0].eligibilityStatus;
        }
    }

    @action.bound
    async setIncludeInDocReqEmail(checked) {
        this.item.includeInDocReqEmail = checked;
        await this.facilityOrderTemplateService.update(this.item);
    }

    @action.bound
    filterMissingDocumentStore(missingDocuments) {
        let result = missingDocuments;
        if (missingDocuments && missingDocuments.some(m => m)) {
            let facilityOrderTemplateItems = this.facilityOrderTemplate && this.facilityOrderTemplate.facilityOrderTemplateItems;

            const deleteImportActionId = this.lookups.importAction.find(x => x.abrv === 'delete').id;

            const diabeticFormulaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "diabetic-formula").id;
            const renalFormulaNeproNRSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "renal-formula-nepro-nr").id;
            const renalFormulaSuplenaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "renal-formula-suplena").id;
            const pulmonaryFormulaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "pulmonary-formula").id;
            const elementalFormulaSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "elemental-formula").id;
            const proteinSupplementSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "protein-supplement").id;
            const siliconeCatheterSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "silicone-catheter").id;
            const coudeCatheterSpecialtyTypeId = this.lookups.specialtyType.find(x => x.abrv === "coude-catheter").id;

			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == diabeticFormulaSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-diabetic");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == renalFormulaNeproNRSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-renal-nepro");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == renalFormulaSuplenaSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-renal-suplena");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == pulmonaryFormulaSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-pulmonary");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == elementalFormulaSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-elemental");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == proteinSupplementSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-protein-supplement");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == siliconeCatheterSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-silicone-catheter");
			}
			if(!(facilityOrderTemplateItems && facilityOrderTemplateItems.some(i => i.importActionId != deleteImportActionId && i.product && i.product.specialtyTypeId == coudeCatheterSpecialtyTypeId))){
				result = result.filter(i => i.abrv !== "specialty-product-justification-coude-catheter");
			}
		}
		return result;
	}

    @action.bound
    openFacilityOrderTemplateMissingDocumentNoteModal(missingDocument) {
        if (this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments.find(x => x.missingDocument.id == missingDocument.id)) {
            this.facilityOrderTemplateMissingDocumentNoteModal.open({
                missingDocument: _.extend(missingDocument, { facilityOrderTemplateId: this.facilityOrderTemplate.id, facilityOrderTemplateMissingDocumentId: this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments.find(x => x.missingDocument.id == missingDocument.id).id })
            });
        }
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            var response = await this.actions.update({
                id: this.id,
                isPartialUpdate: true,
                facilityOrderTemplateMissingDocuments: resource.facilityOrderTemplateMissingDocuments
            });
            
            this.facilityOrderTemplate.facilityOrderTemplateMissingDocuments = response.facilityOrderTemplateMissingDocuments;
            this.form.setFieldsDisabled(false);
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    openPatientMissingDocsPreview() {
        return this.rootStore.routerStore.goTo('master.app.main.facility-missing-docs.patient-preview',{ id: this.facilityOrderTemplate.patientId });
    }

    @action.bound
    changeItemVisibility() {
        this.isItemVisible = !this.isItemVisible;
    }
}

export default FacilityMissingDocsEditViewStore;
